/*eslint-disable*/
import {
  Box,
  Button,
  Flex,
  Link,
  Stack,
  Text,
  useColorModeValue,
  useColorMode,
  Icon,
  Badge,
  HStack,
  Tooltip,
} from "@chakra-ui/react";
import IconBox from "components/Icons/IconBox";
import { Separator } from "components/Separator/Separator";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import logoDark from "../../assets/img/xplogo2.png";
import logoWhite from "../../assets/img/xpwhitelogo.png";
import { FaDatabase } from "react-icons/fa";
import { FiLogIn } from "react-icons/fi";
import { isTokenValid } from "utils/auth";

const SidebarContent = ({ logoText, routes }) => {
  let location = useLocation();
  const { colorMode } = useColorMode();

  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };

  const createLinks = (routes) => {
    const activeBg = "linear-gradient(135deg, #0d9488 0%, #06b6d4 100%)";
    const activeIconBg = "whiteAlpha.300";
    const inactiveIconBg = useColorModeValue("slate.100", "navy.600");
    const activeColor = "white";
    const inactiveColor = useColorModeValue("slate.600", "slate.300");
    const hoverBg = useColorModeValue("rgba(13, 148, 136, 0.08)", "rgba(6, 182, 212, 0.12)");

    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.category) {
        return (
          <Box key={prop.name} mt="12px" mb="4px">
            <HStack spacing="6px" ps="10px" py="2px">
              <Box w="5px" h="5px" borderRadius="full" bg="teal.400" />
              <Text
                color={useColorModeValue("slate.400", "slate.400")}
                fontWeight="800"
                fontSize="9px"
                letterSpacing="0.1em"
                textTransform="uppercase"
              >
                {prop.name}
              </Text>
            </HStack>
            {createLinks(prop.views)}
          </Box>
        );
      }
      const isActive = activeRoute(prop.layout + prop.path) === "active";
      return (
        <NavLink to={prop.layout + prop.path} key={prop.name}>
          <Button
            boxSize="initial"
            justifyContent="flex-start"
            alignItems="center"
            bg={isActive ? activeBg : "transparent"}
            shadow={
              isActive
                ? "0 6px 16px rgba(13, 148, 136, 0.35)"
                : "none"
            }
            mb="4px"
            mx="auto"
            ps="10px"
            pe="12px"
            py="9px"
            borderRadius="14px"
            w="100%"
            position="relative"
            overflow="hidden"
            transition="all 0.25s cubic-bezier(0.4, 0, 0.2, 1)"
            _hover={{
              bg: isActive ? activeBg : hoverBg,
              transform: "translateX(4px)",
            }}
            _active={{
              bg: isActive ? activeBg : hoverBg,
              transform: "scale(0.98)",
            }}
            _focus={{
              boxShadow: "none",
            }}
          >
            {isActive && (
              <Box
                position="absolute"
                left="0"
                top="20%"
                bottom="20%"
                w="3px"
                borderRadius="r-full"
                bg="white"
                shadow="0 0 8px white"
              />
            )}
            <Flex align="center" w="100%">
              {typeof prop.icon === "string" ? (
                <Icon me="10px">{prop.icon}</Icon>
              ) : (
                <IconBox
                  bg={isActive ? activeIconBg : inactiveIconBg}
                  color={isActive ? "white" : useColorModeValue("teal.600", "teal.300")}
                  h="30px"
                  w="30px"
                  me="10px"
                  borderRadius="10px"
                  shadow={isActive ? "inset 0 0 8px rgba(255,255,255,0.2)" : "none"}
                >
                  {prop.icon}
                </IconBox>
              )}
              <Text
                color={isActive ? activeColor : inactiveColor}
                fontWeight={isActive ? "700" : "500"}
                fontSize="xs"
                my="auto"
                letterSpacing="-0.01em"
              >
                {prop.name}
              </Text>
            </Flex>
          </Button>
        </NavLink>
      );
    });
  };

  const links = <>{createLinks(routes)}</>;

  const logo = colorMode === "dark" ? logoWhite : logoDark;

  return (
    <Flex direction="column" justify="space-between" h="100%">
      {/* Top Header Logo */}
      <Box pt="12px" mb="8px">
        <NavLink
          to="/"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textDecoration: "none",
          }}
        >
          <Box display="flex" flexDirection="column" alignItems="center" px="10px">
            <Box position="relative">
              <Box
                position="absolute"
                inset="-4px"
                borderRadius="full"
                bg="radial-gradient(circle, rgba(13, 148, 136, 0.25) 0%, rgba(0,0,0,0) 70%)"
                pointerEvents="none"
              />
              <img src={logo} alt="XP Tunisia Logo" style={{ maxHeight: "60px", objectFit: "contain", position: "relative" }} />
            </Box>
            <Text fontSize="11px" fontWeight="800" color={useColorModeValue("teal.600", "teal.300")} letterSpacing="0.08em" mt="6px">
              TUNISIAN XP DATABASE
            </Text>

          </Box>
        </NavLink>
        <Separator borderColor={useColorModeValue("slate.200", "whiteAlpha.200")} width="90%" mx="auto" mt="10px" />
      </Box>

      {/* Nav Links Stack */}
      <Stack direction="column" mb="10px" flex="1">
        <Box px="2px">{links}</Box>
      </Stack>



    </Flex>
  );
};

export default SidebarContent;